module.exports = __webpack_public_path__ + "static/media/imagenet3.df4f16c1.png";